import type { Config } from "@/config";

const CLARITY_PROJECT_ID = "ufne066t2v";
const CLARITY_SCRIPT_ID = "ms-clarity";

/**
 * Initialise Microsoft Clarity analytics.
 * Skipped entirely in local development to avoid COEP/CORS console errors.
 */
export function initClarity(environment: Config["ilEnv"]): void {
  if (environment === "local") return;

  if (document.getElementById(CLARITY_SCRIPT_ID)) return;

  const w = window as unknown as Record<string, unknown>;

  if (!w.clarity) {
    const queue: unknown[][] = [];
    w.clarity = (...args: unknown[]) => {
      queue.push(args);
    };
    (w.clarity as unknown as { q: unknown[][] }).q = queue;
  }

  const script = document.createElement("script");
  script.id = CLARITY_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`;
  document.head.appendChild(script);
}
